/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  InputAudio,
  InputAudio$inboundSchema,
  InputAudio$Outbound,
  InputAudio$outboundSchema,
} from "./inputaudio.js";
import {
  InputFile,
  InputFile$inboundSchema,
  InputFile$Outbound,
  InputFile$outboundSchema,
} from "./inputfile.js";
import {
  InputImage,
  InputImage$inboundSchema,
  InputImage$Outbound,
  InputImage$outboundSchema,
} from "./inputimage.js";
import {
  InputText,
  InputText$inboundSchema,
  InputText$Outbound,
  InputText$outboundSchema,
} from "./inputtext.js";
import {
  OutputText,
  OutputText$inboundSchema,
  OutputText$Outbound,
  OutputText$outboundSchema,
} from "./outputtext.js";
import {
  Refusal,
  Refusal$inboundSchema,
  Refusal$Outbound,
  Refusal$outboundSchema,
} from "./refusal.js";

export type InputMessageContent =
  | InputText
  | InputAudio
  | OutputText
  | Refusal
  | InputImage
  | InputFile
  | string;

/** @internal */
export const InputMessageContent$inboundSchema: z.ZodType<
  InputMessageContent,
  z.ZodTypeDef,
  unknown
> = z.union([
  InputText$inboundSchema,
  InputAudio$inboundSchema,
  OutputText$inboundSchema,
  Refusal$inboundSchema,
  InputImage$inboundSchema,
  InputFile$inboundSchema,
  z.string(),
]);
/** @internal */
export type InputMessageContent$Outbound =
  | InputText$Outbound
  | InputAudio$Outbound
  | OutputText$Outbound
  | Refusal$Outbound
  | InputImage$Outbound
  | InputFile$Outbound
  | string;

/** @internal */
export const InputMessageContent$outboundSchema: z.ZodType<
  InputMessageContent$Outbound,
  z.ZodTypeDef,
  InputMessageContent
> = z.union([
  InputText$outboundSchema,
  InputAudio$outboundSchema,
  OutputText$outboundSchema,
  Refusal$outboundSchema,
  InputImage$outboundSchema,
  InputFile$outboundSchema,
  z.string(),
]);

export function inputMessageContentToJSON(
  inputMessageContent: InputMessageContent,
): string {
  return JSON.stringify(
    InputMessageContent$outboundSchema.parse(inputMessageContent),
  );
}
export function inputMessageContentFromJSON(
  jsonString: string,
): SafeParseResult<InputMessageContent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => InputMessageContent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'InputMessageContent' from JSON`,
  );
}
